import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { ChevronRightIcon } from '@heroicons/react/24/outline';

export const WorkbookNavItemScrollArea = ({ children }) => {
  const [show, setShow] = useState(false);
  const scrollAreaRef = useRef(null);
  useEffect(() => {
    if (scrollAreaRef.current) {
      scrollAreaRef.current.classList.add('h-[calc(80vh-1px)]');
      scrollAreaRef.current.classList.remove('h-10');
    }
    setShow(true);
  });
  return (
    <div className="relative flex">
      <ChevronRightIcon
        className="absolute top-14 left-5 z-30 hidden size-10 rounded-lg bg-white transition-[rotate] data-[show=true]:rotate-90 lg:block"
        data-show={show}
      ></ChevronRightIcon>
      <div
        ref={scrollAreaRef}
        className="no-scrollbar joyride-nav-open absolute left-0 z-20 flex h-10 w-full flex-col overflow-x-hidden overflow-y-scroll rounded-2xl border-1 border-gray-200 bg-white shadow-md transition-[height] duration-500 lg:px-15 px-3"
      >
        {children}
      </div>
    </div>
  );
};

WorkbookNavItemScrollArea.propTypes = {
  children: PropTypes.node
};
